// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DateHelper  {
    _originalTypeClassName = "Loom.BO.DateHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DateHelper.translate = translateService;
}
this.DateHelperKey = null;
this._key = this.DateHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DateHelperKey:any;
get DateHelperKey(): any {
    return this._DateHelperKey;
  }
set DateHelperKey(value: any) {
    this._DateHelperKey = value;
    this._key = value;
  }

static Format(date: any): any{return CLMS.Framework.DateTime.ToString(date, "dd/MM/yyyy");
}
static IsNull(date: any): any{return date == null || CLMS.Framework.Number.LessThan(() => moment(date).year(), () => 1900);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DateHelperKey == null || $this.DateHelperKey == 0;
            }


}